import { render } from "./EditProfile.vue?vue&type=template&id=b675e764&scoped=true&ts=true"
import script from "./EditProfile.vue?vue&type=script&lang=ts"
export * from "./EditProfile.vue?vue&type=script&lang=ts"

import "./EditProfile.vue?vue&type=style&index=0&id=b675e764&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b675e764"]])

export default __exports__